'use client';

import { defineMessages, useIntl } from 'react-intl';

import { Input } from '@packages/shared/src/ui/Input/Input';

const messages = defineMessages({
  serviceCount: {
    id: 'Aplus.serviceCount',
    defaultMessage: 'Anzahl',
  },
});

const minimum = 1;

const getSanitizedValue = (value: number | string, min: number, max: number | null) => {
  let parsedValue: number;
  try {
    parsedValue = parseInt(value as string, 10);
  } catch {
    parsedValue = min;
  }
  if (Number.isNaN(parsedValue) || parsedValue < min) parsedValue = min;
  if (max !== null && parsedValue > max) parsedValue = max;
  return parsedValue;
};

type ServiceCountProps = {
  uuid: string;
  count: number;
  maximum: number | null;
  onCountChangeHandler: (uuid: string, count: number) => void;
};

export const ServiceCount = ({ uuid, count, maximum, onCountChangeHandler }: ServiceCountProps) => {
  const { formatMessage } = useIntl();
  // the quantity belongs to whoever renders the list, so that dropping a change the backend did
  // not take shows here too
  const value = getSanitizedValue(count, minimum, maximum);

  const onChange = (newValue: string) => {
    onCountChangeHandler(uuid, getSanitizedValue(newValue, minimum, maximum));
  };

  return (
    <Input
      type="number"
      label={formatMessage(messages.serviceCount)}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      min={minimum}
      max={maximum ?? undefined}
    />
  );
};
